export default __webpack_public_path__ + "static/media/icon-apple-pay.20a5290a.svg";